import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import "./FriendListContainer.css";
import ProfilePic from "components/General/ProfilePic";

function FriendCell(props) {
  return (
    <div className="my_friend_container">
      <div className="my_friend_card" onClick={props.buttonAction}>
        <div className="my_friend_card_column_main">
          <div className="my_friend_profile_pic">
            <ProfilePic
              profilePic={props.profilePic}
              className="friend_card_profile_pic"
            />
          </div>

          <div className="my_friend_card_detail_rows">
            <div className="friend_details_username">
              <TextTheme
                message={props.userName}
                className={"text_medium text_semi_bold text_dark_blue break-text"}
              />
            </div>
            {!props.isFriendTribe ? (
              <div className="friend_details_date">
                <TextTheme
                  message={props.datePrefix + formatDate(props.date)}
                  className={"text_xsmall text_med_grey"}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

//Refered to function reversedate() in EachActiveProject.js
// time comes in format "2020-10-27T19:21:36.818120Z" and leaves "10-27-2020"
function formatDate(date) {
  //remove all hour-minute-second info
  var dateString = date.split("T");
  var splitString = dateString[0].split("-");
  var newDate = splitString[1] + "/" + splitString[2] + "/" + splitString[0];
  return newDate;
}

export default FriendCell;
